import React from "react";
import { Form, Input, Button, Select, message } from "antd";
import { token } from "../../constants/Constants";
import { useSelector } from "react-redux";
import { fetchCustomers } from "../customer/FetchCustomers";
import { create_poc } from "../../endpoints/API";

const { Option } = Select;

const PointOfContact = ({
  setSelectedCustomerProfile,
  customers,
  baseUrl,
  prodTestUrl,
  fetchCustomerData,
  setIsPOCModalVisible,
}) => {
  const [form] = Form.useForm();
  const user = useSelector((state) => state.user.user);

  const onFinish = async (values) => {
    const payload = {
      ...values,
      created_by: user.user_id,
    };
    try {
      const response = await create_poc(payload);

      if (!response.statusText=="OK") {
        throw new Error("Failed to create point of contact");
      }

      const data = response?.data;
      message.success("Point of contact created successfully");
      form.resetFields();
      setIsPOCModalVisible(false);
    } catch (error) {
      message.error(error?.response?.data?.error||"Something went wrong. Please try again.");
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      className="max-w-md mx-auto p-4 bg-white shadow rounded"
    >
      <Form.Item
        label="Select Customer"
        name="customer"
        rules={[{ required: true, message: "Please select a customer" }]}
      >
        <Select
          placeholder="Select a customer"
          onChange={(value) => setSelectedCustomerProfile(value)}
          showSearch
          optionFilterProp="label"
          filterOption={(input, option) =>
            option?.label?.toLowerCase().includes(input.toLowerCase())
          }
        >
          {customers?.map((customer) => (
            <Option
              key={customer.id}
              value={customer.id}
              label={`${customer.first_name} ${customer.middle_name || ""} ${customer.last_name
                } (${customer.email}) (${customer.phone})`}
            >
              {customer.first_name} {customer.middle_name || ""}{" "}
              {customer.last_name}
              <span> ({customer.email})</span>
              <span> ({customer.phone})</span>
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="First Name"
        name="first_name"
        rules={[{ required: true, message: "Please enter the first name" }]}
      >
        <Input placeholder="Enter first name" />
      </Form.Item>

      <Form.Item label="Middle Name" name="middle_name">
        <Input placeholder="Enter middle name (optional)" />
      </Form.Item>

      <Form.Item
        label="Last Name"
        name="last_name"
        rules={[{ required: true, message: "Please enter the last name" }]}
      >
        <Input placeholder="Enter last name" />
      </Form.Item>

      <Form.Item
        label="Phone Number"
        name="phone"
        rules={[{ required: true, message: "Please enter the phone number" }]}
      >
        <Input type="tel" placeholder="Enter phone number" />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[{ type: "email", message: "Please enter a valid email" }]}
      >
        <Input placeholder="Enter email (optional)" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default PointOfContact;
